export const en = {
  HOME: '/',
  CONTENT: '/[...content]',
  NEWS_LISTING: '/news',
  NEWS_LISTING_BY_SLUG: '/news/listing/[newsListing]',
  NEWS_CATEGORY: '/news/category/[category]',
  NEWS_TAG: '/news/tag/[tag]',
  ARTICLE: '/news/[article]',
  MATCH_CENTRE: '/matches/[team]/[fixture]',
  FIXTURES: '/matches/[team]/fixtures',
  FIXTURES_COMPETITION: '/matches/[team]/fixtures/[competition]',
  RESULTS: '/matches/[team]/results',
  RESULTS_COMPETITION: '/matches/[team]/results/[competition]',
  RESULTS_COMPETITION_SEASON: '/matches/[team]/results/[competition]/[season]',
  TABLE: '/matches/[team]/table',
  TABLE_COMPETITION: '/matches/[team]/table/[competition]',
  TABLE_COMPETITION_SEASON: '/matches/[team]/table/[competition]/[season]',
  TEAM: '/teams/[team]',
  PROFILE: '/teams/[team]/[profile]',
  TEAM_YOUTH: '/teams/youth/[team]',
  PROFILE_YOUTH: '/teams/youth/[team]/[profile]',
  VIDEO_LANDING: '/video',
  VIDEO_DETAIL: '/video/[slug]',
  VIDEO_CATEGORY: '/video/category/[category]',
  VIDEO_PLAYLIST_LISTING: '/video/playlists',
  VIDEO_PLAYLIST: '/video/playlists/[slug]',
  VIDEO_COLLECTION: '/video/collection/[collection]',
} as const;
